import React from "react";
import { NavLink } from "react-router-dom";
import { USER_ROLES } from "../../interfaces/roles";
import "../../assets/scss/pages/admin/_sidebarAdmin.scss";

interface TabItem {
	name: string;
	route: string;
	icon?: React.ElementType;
	tabRoles?: USER_ROLES[];
}

interface SidebarProps {
	tabs: TabItem[];
	userRole: USER_ROLES;
	viewMode: 'compact' | 'expanded';
	onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ tabs, userRole, viewMode, onToggle }) => {
	const isCompact = viewMode === 'compact';

	return (
		<div className={`admin-sidebar ${isCompact ? 'admin-sidebar--compact' : 'admin-sidebar--expanded'}`}>
			{/* Header */}
			<div className="admin-sidebar__header">
				{!isCompact && <span className="admin-sidebar__title">Admin</span>}
				<button
					className="admin-sidebar__toggle"
					onClick={onToggle}
					aria-label={isCompact ? 'Expand sidebar' : 'Collapse sidebar'}
					title={isCompact ? 'Expand sidebar' : 'Collapse sidebar'}
				>
					{isCompact ? (
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					) : (
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
							<path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					)}
				</button>
			</div>

			{/* Nav Links */}
			<nav className="admin-sidebar__nav">
				{tabs
					.filter((tab) => !tab.tabRoles || tab.tabRoles.includes(userRole))
					.map((tab) => {
						const Icon = tab.icon;
						return (
							<NavLink
								key={tab.name}
								to={tab.route}
								exact
								className="admin-sidebar__link"
								activeClassName="admin-sidebar__link--active"
								title={isCompact ? tab.name : undefined}
							>
								{Icon && <Icon className="admin-sidebar__icon" />}
								{!isCompact && <span className="admin-sidebar__label">{tab.name}</span>}
							</NavLink>
						);
					})}
			</nav>
		</div>
	);
};

export default Sidebar;
